import { IOrderItem, IDiscountItemMap } from '../../model/order.store'
import { includes, forEach, orderBy } from 'lodash'
import { isBefore, isAfter } from 'date-fns'
import { getItemSoldPrice } from '../order.util'

/**
 * Chương trình mua 2 tính tiền 1 (mua 1 tặng 1) cho V10730 và V10176
 * - Chỉ áp dụng cơ sở: E9, S6, B7, E62
 * - Xét trong phạm vi 2 mã V10730 + V10176, mua 2 free 1 cái rẻ nhất
 * - Không áp dụng cộng dồn các chương trình khác
 * - Áp dụng đến hết 10/3/2026
 */

const BUY2PAY1_SKUS = ['V10730', 'V10176']

const VALID_OUTLET_CODES = ['E9', 'S6', 'B7', 'E62']

const PROGRAM_START = new Date('2026-03-09T00:00:00+07:00')
const PROGRAM_END = new Date('2026-03-21T00:00:00+07:00') // hết ngày 20/3

interface IProcessBuy2Pay1Params {
  items: IOrderItem[]
  resultMap: IDiscountItemMap
  orderPlatform: string
  orderType: string
  outletCode: string
}

export function processBuy2Pay1Sale({
  items,
  resultMap,
  orderPlatform,
  orderType,
  outletCode
}: IProcessBuy2Pay1Params): void {
  if (orderPlatform !== 'SAVOR_SHOP') {
    return
  }

  // Check thời gian
  const now = new Date()
  if (isBefore(now, PROGRAM_START) || isAfter(now, PROGRAM_END)) {
    return
  }

  // Check cơ sở
  if (!includes(VALID_OUTLET_CODES, outletCode)) {
    return
  }

  // Expand từng item ra để sort theo giá và free cái rẻ nhất
  const expandedItems: { sku: string; soldPrice: number; itemId: string }[] = []
  forEach(items, item => {
    if (!includes(BUY2PAY1_SKUS, item.sku)) {
      return
    }
    const soldPrice = getItemSoldPrice({ item, orderPlatform, orderType })
    for (let i = 0; i < item.quantity; i++) {
      expandedItems.push({ sku: item.sku, soldPrice, itemId: item.id })
    }
  })

  const totalQuantity = expandedItems.length
  if (totalQuantity < 2) {
    return
  }

  // Mua 2 tính 1 -> free floor(total / 2) cái
  const numFreeItems = Math.floor(totalQuantity / 2)

  // Sort giá tăng dần, free cái rẻ nhất trước
  const sortedItems = orderBy(expandedItems, ['soldPrice'], ['asc'])

  // Tính discount theo itemId
  const discountByItemId: { [itemId: string]: number } = {}
  let remainingFree = numFreeItems

  forEach(sortedItems, expandedItem => {
    if (remainingFree <= 0) {
      return
    }
    discountByItemId[expandedItem.itemId] =
      (discountByItemId[expandedItem.itemId] || 0) + expandedItem.soldPrice
    remainingFree--
  })

  // Áp dụng discount - không cộng dồn: xóa discount cũ của tất cả item thuộc chương trình
  forEach(items, item => {
    if (!includes(BUY2PAY1_SKUS, item.sku)) {
      return
    }
    const buy2Pay1Discount = discountByItemId[item.id] || 0
    resultMap[item.id].discount = buy2Pay1Discount
    resultMap[item.id].saleProgram = buy2Pay1Discount > 0 ? 'Mua 1 tặng 1 set quà bánh' : ''
  })
}
